<template>
    <div>
        <b-link :title="title" @click="openModal">
            <span v-if="appointmentIsNotSet" class="small">
                <i class="fas fa-fw fa-clock"></i>
            </span>
            <span v-else class="small">
                {{ appointment.deadline_date | moment('D/M') }}
            </span>
        </b-link>

        <b-modal
            :id="'appointment-modal-id' + client.id"
            :key="'appointment-modal-key' + client.id"
            :title="title"
            hide-footer
            no-close-on-backdrop
            size="sm"
        >
            <p class="mb-2 font-weight-bold">{{ client.name }}</p>
            <appointment-form :client-deadline="appointment" :client="client" />
        </b-modal>
    </div>
</template>

<script>
import appointmentForm from './appointmentForm'

export default {
    name: 'AppointmentHandler',

    components: {
        appointmentForm,
    },

    props: {
        client: {},
        appointment: {},
    },

    computed: {
        appointmentIsNotSet() {
            return this.appointment === null
        },

        title() {
            return this.appointmentIsNotSet
                ? 'Définir le rendez-vous'
                : 'Modifier le rendez-vous'
        },
    },

    methods: {
        openModal() {
            this.$bvModal.show(`appointment-modal-id${this.client.id}`)
        },
        setAppointment() {
            alert(`OK${this.appointment.client}`)
        },
    },
}
</script>

<style scoped></style>
